import { render, staticRenderFns } from "./page-block.vue?vue&type=template&id=88cb453a&"
import script from "./page-block.vue?vue&type=script&lang=js&"
export * from "./page-block.vue?vue&type=script&lang=js&"
import style0 from "./page-block.vue?vue&type=style&index=0&id=88cb453a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports